import { Component, Output, EventEmitter, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { HospitalTitlecasePipe } from "../../../../../../pipes/hospital-titlecase.pipe";


@Component({
  selector: 'app-modal-open-to-economia-curve',
  imports: [CommonModule, HospitalTitlecasePipe],
  templateUrl: './modal-open-to-economia-curve.component.html',
  styleUrl: './modal-open-to-economia-curve.component.css'
})
export class ModalOpenToEconomiaCurveComponent implements OnInit, OnDestroy {
  @Output() isModalOpen = new EventEmitter<boolean>()
  @Input() curvePointData: any = {};
  activeIndexes: number[] = [];

  Regioni: any[] = [];
  medicineId: number = 0;
  countryId: number = 1; // Default to Italy
  isLoading: boolean = true;


  constructor (private dataService: DataService) { }

  ngOnInit () {
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';

    this.medicineId = sessionStorage.getItem('medicineId') ? parseInt(sessionStorage.getItem('medicineId')!, 10) : 0;
    this.countryId = sessionStorage.getItem('countryId') ? parseInt(sessionStorage.getItem('countryId')!, 10) : 1;

    if (this.curvePointData.type === 'Forecast') {
      this.dataService.getRegionsContributorsOpenToEconomiaForecast(this.medicineId, this.countryId, this.curvePointData.month).subscribe({
        next: (data) => {
          this.isLoading = false;
          this.Regioni = data
          this.Regioni.sort((a, b) => b.potentialPercentage - a.potentialPercentage);
          this.Regioni.forEach(region => {
            region.hospitals.sort((a: any, b: any) => b.hospitalPercentage - a.hospitalPercentage);
          });
        },
        error: (err) => {
          this.isLoading = false;
          console.log('error: ', err);
        },
      });
    } else {
      this.dataService.getRegionsContributorsOpenToEconomiaActual(this.medicineId, this.countryId, this.curvePointData.month).subscribe({
        next: (data) => {
          this.isLoading = false;
          this.Regioni = data
          this.Regioni.sort((a, b) => b.potentialPercentage - a.potentialPercentage);
          this.Regioni.forEach(region => {
            region.hospitals.sort((a: any, b: any) => b.hospitalPercentage - a.hospitalPercentage);
          });
        },
        error: (err) => {
          this.isLoading = false;
          console.log('error: ', err);
        },
      });
    }
  }

  toggleAccordion (index: number) {
    const i = this.activeIndexes.indexOf(index);
    if (i > -1) {
      // già attivo → rimuovilo
      this.activeIndexes.splice(i, 1);
    } else {
      // non attivo → aggiungilo
      this.activeIndexes.push(index);
    }
  }

  ngOnDestroy (): void {
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  closeModal () {
    this.isModalOpen.emit(false);
  }
}
